// extracted by mini-css-extract-plugin
export default {"Title":"Step3Chat_Title__kLlSr","TextContainer":"Step3Chat_TextContainer__KzCzs"};